module.exports = __webpack_public_path__ + "media/budgeting_calculators/savings_plan_info-6b4d5f07.png";